import { useModals } from 'almanac-ui/Modal'
import { useMemo } from 'react'
import { Section } from 'screens/blaze/Home/components/Catalogue/components/Section/Section'
import { useFiles } from 'hooks/queries/finder/useFiles'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { collectResults } from 'utils/query'
import { AlmanacFileSummary } from 'types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { FilesTable } from 'screens/RecentDocsContainer/components/FilesTable/FilesTable'
import Styles from './SearchModal.module.scss'
import { FileCardLoader } from 'screens/blaze/Home/components/Catalogue/components/FileCard/FileCardContainer'
import { FileTypeCard } from 'screens/blaze/Home/components/Catalogue/components/FileCard/FileTypeCard'

export const RecentFiles = () => {
  const workspaceId = useCurrentWorkspaceId()
  const { closeAllModals } = useModals()
  const { isMobile } = useResponsiveDesign()
  const title = isMobile ? 'Recently used' : 'Recently edited files'
  const fileTypes = 'projects articles designs videos'

  const recentFilesQuery = useFiles(
    {
      location: 'recents_home',
      workspaceId,
      query: { items: 10, load_children_preview_urls: true },
      disableSchema: true,
    },
    { getNextPageParam: undefined },
  )

  const files = useMemo(
    () => collectResults(recentFilesQuery, (data) => data.files.filter((f) => !f.uploads_project)),
    [recentFilesQuery],
  )

  if (isMobile)
    return (
      <Section title={title} scrollable={false} titleLevel={5}>
        <div className={Styles.itemsList}>
          <FilesTable location="recents_home" workspaceId={workspaceId} skipCreatedByMe fileTypes={fileTypes} />
        </div>
      </Section>
    )

  if (recentFilesQuery.isLoading)
    return (
      <Section title={title} titleLevel={4} size="xs" scrollable={false}>
        <div className={Styles.previewsContainer} data-testid="loading-preview-cards">
          {Array.from(Array(10)).map((_, i) => (
            <FileCardLoader key={i} file={{ type: 'article' } as AlmanacFileSummary} />
          ))}
        </div>
      </Section>
    )

  if (files.length === 0) return null

  return (
    <Section title={title} titleLevel={4} size="xs" scrollable={false}>
      <div className={Styles.previewsContainer}>
        {files.map((file, index) => (
          <FileTypeCard key={file.id} file={file as unknown as AlmanacFileSummary} onPress={closeAllModals} />
        ))}
      </div>
    </Section>
  )
}
